import React, { useEffect } from "react";
import { AuthProvider } from "./context/authContext/authContext";
import { UnidadesProvider } from "./context/unidades/UnidadesContext";
import { AppRouter } from "./routers/AppRouter";
import "react-toastify/dist/ReactToastify.css";
import { SocketProvider } from "./context/SocketContext";
import { SocketStatus } from "./components/Socket/SocketStatus";
import moment from "moment";

export const MainApp = () => {
  useEffect(() => {
    moment.locale("en"); // default the locale to English
    var localLocale = moment();
    localLocale.locale("es"); // set this instance to use French
    localLocale.format("LLLL"); // dimanche 15 juillet 2012 11:01
    moment().format("LLLL"); // Sunday, July 15 2012 11:01 AM
  }, []);

  return (
    // Provedor de autenticación
    <AuthProvider>
      {/* Proveedor de unidades */}
      <UnidadesProvider>
        {/* Ruteador de la aplicación */}
        <SocketProvider>
          <AppRouter />
          <SocketStatus />
        </SocketProvider>
      </UnidadesProvider>
    </AuthProvider>
  );
};
